import { TransferOrderStatus } from './transfer-order-status.js';
export const TERMINAL_TRANSFER_ORDER_STATUS_IDS = [
    TransferOrderStatus.RECEIVED,
    TransferOrderStatus.CANCELLED,
];
//# sourceMappingURL=transfer-order-terminal-statuses.js.map